"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = exports.findInObjectArray = exports.dateArrayToSchedule = exports.composeURLQuery = exports.getDate = exports.composeBaseURL = exports.textToSlug = exports.constructURLParams = void 0;

var _dates = require("../constants/dates");

var _filters = require("./filters");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var constructURLParams = function constructURLParams(args) {
  var schedule = args.schedule,
      addressLine1 = args.addressLine1,
      addressLine2 = args.addressLine2,
      pinnedAddress = args.pinnedAddress,
      rest = _objectWithoutProperties(args, ["schedule", "addressLine1", "addressLine2", "pinnedAddress"]);

  var params = new URLSearchParams();
  if (addressLine1) params.append('addressLine1', addressLine1);
  if (addressLine2) params.append('addressLine2', addressLine2);
  if (pinnedAddress) params.append('pinnedAddress', pinnedAddress);
  Object.keys(rest).forEach(function (key) {
    var value = textToSlug(rest[key]);

    if (value !== undefined) {
      params.append(key, value);
    }
  });

  if (schedule) {
    params.append('schedule', schedule);
  }

  var result = params.toString();
  return result ? "".concat(result) : '';
};

exports.constructURLParams = constructURLParams;

var textToSlug = function textToSlug(text) {
  if (!text) return;
  if (typeof text !== 'string') return text;
  var result = text.toLowerCase();

  while (result.indexOf('-') !== -1) {
    result = result.replace('-', '_');
  }

  while (result.indexOf(' ') !== -1) {
    result = result.replace(' ', '-');
  }

  return result;
};

exports.textToSlug = textToSlug;

var composeBaseURL = function composeBaseURL(params) {
  var _params$groups = params.groups,
      groups = _params$groups === void 0 ? [] : _params$groups,
      gradesList = params.gradesList,
      filters = _objectWithoutProperties(params, ["groups", "gradesList"]);

  var subject = filters.subject;
  var sub = findInObjectArray(groups, 'id', subject);
  if (!sub) return '/';
  var masterGroup = sub.masterGroup;
  return "/".concat(textToSlug(masterGroup.name), "/").concat(textToSlug(sub.title));
};

exports.composeBaseURL = composeBaseURL;

var getDate = function getDate(filters) {
  var dates = filters.dates,
      time = filters.time;

  if (!dates.length || !time) {
    return {};
  }

  var _processTime = processTime(time),
      startTime = _processTime.startTime,
      endTime = _processTime.endTime;

  return {
    dates: dates,
    startTime: startTime,
    endTime: endTime
  };
};

exports.getDate = getDate;

var processTime = function processTime(time) {
  var separator = ' - ';
  if (!time || !time.includes(separator)) return;

  var _time$split = time.split(separator),
      _time$split2 = _slicedToArray(_time$split, 2),
      startTime = _time$split2[0],
      endTime = _time$split2[1];

  return {
    startTime: startTime,
    endTime: endTime
  };
};

var composeURLQuery = function composeURLQuery(params) {
  var _findInObjectArray;

  var groups = params.groups,
      _params$gradesList = params.gradesList,
      gradesList = _params$gradesList === void 0 ? [] : _params$gradesList,
      filters = _objectWithoutProperties(params, ["groups", "gradesList"]);

  var grade = filters.grade;

  var _getDate = getDate(filters),
      dates = _getDate.dates,
      startTime = _getDate.startTime,
      endTime = _getDate.endTime;

  var schedule = dateArrayToSchedule(dates, startTime, endTime);
  var gradeName = (_findInObjectArray = findInObjectArray(gradesList, 'id', grade)) === null || _findInObjectArray === void 0 ? void 0 : _findInObjectArray.title;
  return constructURLParams({
    grade: gradeName,
    schedule: JSON.stringify(schedule)
  });
};

exports.composeURLQuery = composeURLQuery;

var dateArrayToSchedule = function dateArrayToSchedule(dateArray, startTime, endTime) {
  if (!dateArray || !dateArray.length) return undefined;
  return dateArray.map(function (item) {
    var date = new Date(item);

    var weekday = _dates.Days[date.getDay()].label;

    return {
      date: formatDate(date),
      day: weekday,
      slotFrom: (0, _filters.getTime12)(startTime),
      slotTo: (0, _filters.getTime12)(endTime)
    };
  });
};

exports.dateArrayToSchedule = dateArrayToSchedule;

var findInObjectArray = function findInObjectArray(array, key, value, useLowerCase) {
  return array.find(function (val) {
    if (typeof value === 'string' && useLowerCase) {
      return val[key].toLowerCase() === value.toLowerCase();
    }

    return val[key] === value;
  });
};

exports.findInObjectArray = findInObjectArray;

var formatDate = function formatDate(date) {
  if (!date) return;
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return [date.getFullYear(), (month > 9 ? '' : '0') + month, (day > 9 ? '' : '0') + day].join('-');
};

exports.formatDate = formatDate;